import CustomizedView from './customizedView';
import SimpleView from './simpleView';
import SortView from './sortView';
import FilterView from './filterView';
import GroupView from './groupView';
import EditView from './editView';

export {
  SimpleView,
  SortView,
  CustomizedView,
  FilterView,
  GroupView,
  EditView,
};



// WEBPACK FOOTER //
// ./src/containers/Tables/antTables/tableViews/index.js